export default __webpack_public_path__ + "static/media/O-095.9bb66452.png";